import { render } from "./ApiCredentialGenerationConfirmationDialog.vue?vue&type=template&id=0bd1d94a"
import script from "./ApiCredentialGenerationConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ApiCredentialGenerationConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__